

export const  isUserLogin = async(navigation) => {
    const token = await localStorage.getItem("token")
    if(!token){
      return navigation('/')
    }
}